export const CategoryGuids = {
  // Top-level categories
  AUTO_AND_TRANSPORT: 'CAT-7829f71c-2e8c-afa5-2f55-fa3634b89874',
  BILLS_AND_UTILITIES: 'CAT-79b02f2f-2adc-88f0-ac2b-4e71ead9cfc8',
  BUSINESS_SERVICES: 'CAT-94b11142-e97b-941a-f67f-6e18d246a23f',
  EDUCATION: 'CAT-bf5c9cca-c96b-b50d-440d-38d9adfda5b0',
  ENTERTAINMENT: 'CAT-e04e9d1e-e041-c315-2e50-094143ab3f73',
  FEES_AND_CHARGES: 'CAT-d73ee74b-13a4-ac3e-4015-fc4ba9a62b2a',
  FINANCIAL: 'CAT-6c7de3f8-de6c-7061-1dd2-b093044014bf',
  FOOD_AND_DINING: 'CAT-bd56d35a-a9a7-6e10-66c1-5b9cc1b6c81a',
  GIFTS_AND_DONATIONS: 'CAT-8edf9663-623e-4735-490e-31288f0a70b0',
  HEALTH_AND_FITNESS: 'CAT-52fa4693-c088-afb2-2a99-7bc39bb23a0f',
  HOME: 'CAT-b709172b-4eb7-318e-3b5d-e0f0500b32ac',
  INCOME: 'CAT-bf9f3294-4c40-1677-d269-54fbc189faf3',
  INVESTMENTS: 'CAT-ccd42390-9e8c-3fb6-a5d9-6c31182d9c5c',
  KIDS: 'CAT-0cb1d99d-f558-99e3-2282-b31f359b411a',
  PERSONAL_CARE: 'CAT-e5154228-fe45-790d-a280-f6bf5ae5ac9f',
  PETS: 'CAT-7cccbafa-87d7-c9a6-661b-8b3402fe9e78',
  SHOPPING: 'CAT-aad51b46-d6f7-3da5-fd6e-492328b3023f',
  TAXES: 'CAT-d00fc539-aa14-009b-4ffb-7e8c7b839954',
  TRANSFER: 'CAT-bce48142-fea4-ff45-20d9-0a642d44de83',
  TRAVEL: 'CAT-ea23d844-cbd1-eb10-f6ac-0df9610e59ae',
  UNCATEGORIZED: 'CAT-d7851c65-3353-e490-1953-fb9235e681e4',
  // Subcategories
  LOCAL_TAX: 'CAT-0bbdacce-ba14-3e73-e1aa-cc64e671575c',
  WITHDRAWAL: 'CAT-00c762a2-be42-c735-2d3f-b14a1e58453f',
  TRADE_COMMISSIONS: 'CAT-1a01ddd4-9a37-b96b-33dc-6c68457e7806',
  BABYSITTER_DAYCARE: 'CAT-2ba97a5c-a371-3b4f-d018-cba64bb9767a',
  CHILD_SUPPORT: 'CAT-2cb0a3a8-3f05-9325-1203-27ed2d619dce',
  CREDIT_CARD_PAYMENT: 'CAT-2cc9b500-e09d-88be-e3e0-0a8a82a54586',
  STUDENT_LOAN: 'CAT-2ce4972e-5620-57be-8475-d084edf88888',
  LIFE_INSURANCE: 'CAT-2cf64b94-e966-0949-0d07-b211080ddaa6',
  PRINTING: 'CAT-3b09fb0b-3296-c76c-2bbd-a2bce0012d83',
  FINANCIAL_ADVISOR: 'CAT-3db5697d-5dce-6bd9-c08f-5065b25e96c8',
  INTEREST_INCOME: 'CAT-5aa555dc-a071-c727-8d04-cb337832d342',
  LATE_FEE: 'CAT-5bfddc95-a506-b1d2-0f73-63b1afeddb91',
  LAWN_GARDEN: 'CAT-5cc7f5e2-3f2e-61ce-52e7-4acf366c2ee3',
  FINANCE_CHARGE: 'CAT-5dab8347-e0b4-daf9-0a65-f2be80feb8ad',
  FRAUD_PROTECTION: 'CAT-5f7f2084-6f8a-d927-6fa7-8e699912432a',
  MOVIES_DVDS: 'CAT-6ab65efd-36e4-69ca-969a-a7304d05240a',
  HOME_INSURANCE: 'CAT-6cb40bc6-0c0d-6fae-db3b-62a6bc4bb1a2',
  CASH: 'CAT-08a5d861-2890-686e-ebaf-d7632ec88540',
  TUITION: 'CAT-8b01fafd-9bf5-7999-49c9-cb67da50b14d',
  HEALTH_INSURANCE: 'CAT-8faa2a11-f393-9c13-2885-e7d11fa6a51a',
  DIVIDEND_CAP_GAINS: 'CAT-9b21122f-bd17-97ce-ef5c-3f034e75fd6c',
  ALCOHOL_BARS: 'CAT-9d58b17b-0982-18b5-5a6e-8a76337c4f88',
  LEGAL: 'CAT-13c1e57c-3749-41b4-3bc4-b1b334adab85',
  PUBLIC_TRANSPORTATION: 'CAT-19e6ec13-83ed-5511-7f75-3688d3f97a8e',
  MORTGAGE_RENT: 'CAT-23b4b4c6-5fbb-9299-b887-4b56196e6fb4',
  HOTEL: 'CAT-28be9904-9f4c-c4af-d2b7-bb24763ae0ae',
  TRANSFER_FOR_CASH_SPENDING: 'CAT-28d5fc92-cb41-8daa-3ab7-6f7bbde118fb',
  UTILITIES: 'CAT-56a2979d-d6df-25da-f357-06282f08208e',
  DEPOSIT: 'CAT-58aced66-6d70-4024-7667-77e98b6e5805',
  HOME_PHONE: 'CAT-60d81dd3-8ac1-a6fb-b181-b736dbb42be3',
  SERVICE_PARTS: 'CAT-67a20fb1-1a61-dc27-3fff-f28fa904025f',
  INTERNET: 'CAT-78d29c63-54db-197d-9851-feeb94cf6e10',
  BOOKS: 'CAT-80a40aa1-9f7e-2393-0dfe-b222dc8099a2',
  NEWSPAPERS_MAGAZINES: 'CAT-84f5a582-f620-bea1-fb2c-a746094e9955',
  FAST_FOOD: 'CAT-88cbb033-0fc1-ff06-6532-0f357c0f5081',
  COFFEE_SHOPS: 'CAT-93ebd80b-4801-cf52-e844-91594ed4c217',
  SELL: 'CAT-095e8e70-f5fa-9e68-8187-6cac76d14f85',
  OFFICE_SUPPLIES: 'CAT-97a2b899-5a32-4196-b87c-a8e65d8a9849',
  PET_GROOMING: 'CAT-99b03e0f-c678-268b-a97c-81092e68efab',
  AMUSEMENT: 'CAT-163c92ab-5ac1-3125-6a0b-c3aff5cdbb59',
  BOOKS_SUPPLIES: 'CAT-167d816f-c68e-9988-e064-173dc6417a90',
  VACATION: 'CAT-206fbc35-a569-c89a-30be-a3b65d0fbea7',
  SERVICE_FEE: 'CAT-386e01dd-8cc0-a433-f4a9-b3a2d153abbf',
  GIFT: 'CAT-465a2e70-099b-dc43-4422-913c21311002',
  CHARITY: 'CAT-583f1ede-3608-3ec6-b39b-0874198626ed',
  PARKING: 'CAT-726da718-d572-1e4d-7c3f-0b8b5370fe71',
  SHIPPING: 'CAT-748efd05-e27a-5c79-1217-681a0ec5cc67',
  ARTS: 'CAT-967a9441-5694-9419-6b40-67f15cd55fe4',
  PAYCHECK: 'CAT-982ea9e6-3f0e-0c5b-611b-6657a10ba819',
  FURNISHINGS: 'CAT-2910e436-7fed-f922-184c-60bc1b6c5417',
  RESTAURANTS: 'CAT-006862be-64a0-e778-f035-0936445b9c16',
  SPA_MASSAGE: 'CAT-8008cdab-ba5c-26e9-310d-a3ff4afeeb62',
  RENTAL_CAR_TAXI: 'CAT-9588eaad-90a4-bb5c-66c8-1812503d0db8',
  ALLOWANCE: 'CAT-9961e379-d9e9-490c-1c4b-bfa233899167',
  BANKING_FEE: 'CAT-30283e5b-f0fb-d8ab-a9fd-de992b508eac',
  BUY: 'CAT-70215a5e-bd15-e0ac-3842-058b5e8e99b7',
  STATE_TAX: 'CAT-7248227b-303e-ee19-e30c-c4f389da169b',
  TOYS: 'CAT-7524310a-da68-ac09-2312-71ca60a40ec0',
  KIDS_ACTIVITIES: 'CAT-32012156-b11d-a1db-9697-b15432e18215',
  RENTAL_INCOME: 'CAT-67070667-8b54-b450-4e84-5f8da2d70d85',
  VETERINARY: 'CAT-71380790-762a-6e2a-d79e-d7f47689af25',
  SPORTING_GOODS: 'CAT-a9abd9b1-2e2c-4236-040d-fb414d334419',
  LAUNDRY: 'CAT-a9fb2085-ce57-a196-4cbd-338c85bae0b0',
  CLOTHING: 'CAT-a96c2e17-f69a-9805-34aa-633276a42cec',
  PHARMACY: 'CAT-a5600b35-c9b1-347d-f678-781597851104',
  HOME_SERVICES: 'CAT-a64154ee-d5e9-09c7-d5f1-59b3273c6e3c',
  ATM_FEE: 'CAT-ac2eba3a-100a-30ac-09c3-d7d88415ca1a',
  HAIR: 'CAT-af671119-50a2-636c-ddfe-c794c38e8181',
  GROCERIES: 'CAT-b1de2a04-db08-b6ed-f6fe-ca2f5b11c2d0',
  GAS: 'CAT-b6d63a19-30a7-e852-2703-bdfb4072289e',
  FEDERAL_TAX: 'CAT-b8cc4011-cdc9-10b0-b79d-bf1d534296dc',
  HOSTING: 'CAT-b74fdd98-4391-8015-eafa-e9ca0fad3bee',
  TELEVISION: 'CAT-b316e683-c898-6497-a476-6bc48d12e51d',
  MOBILE_PHONE: 'CAT-b4789667-6acc-a112-975e-15746003ed61',
  BABY_SUPPLIES: 'CAT-c9c99041-e009-4a45-4b1d-fa92daeb5dd4',
  MUSIC: 'CAT-c874ccff-d069-40df-d7c5-ddba6fbdd225',
  MORTGAGE_PAYMENT: 'CAT-c94442a5-a762-8830-4c80-2a2f6a79e627',
  SPORTS: 'CAT-cb3de962-ea82-27a9-d096-c232caeb96bd',
  AUTO_PAYMENT: 'CAT-cb93691a-684d-b326-4c32-f8abaecfde90',
  GYM: 'CAT-cd9f9f60-622d-0488-d203-044c8726a7eb',
  REIMBURSEMENT: 'CAT-ce7b7bc8-71b7-9f41-af10-b8c2d5bafc37',
  AIR_TRAVEL: 'CAT-cf82d772-fbe2-4658-303a-f4cd13d9c3c2',
  EYECARE: 'CAT-cf183729-fb60-d16a-32d0-2e1d21ff21cd',
  HOBBIES: 'CAT-d1e54c52-80cc-01ba-3907-5bbdaa0ff521',
  SALES_TAX: 'CAT-d1244982-f8d0-09b8-77bb-6495c6e0c12a',
  ELECTRONICS_SOFTWARE: 'CAT-db5d480c-5130-b42e-def4-f6dabf9c1d10',
  DOCTOR: 'CAT-db6391b3-c218-fbe5-e496-139dca993645',
  RETURNED_PURCHASE: 'CAT-dc201021-6aa2-636b-f041-8577e6f1bc73',
  HOME_IMPROVEMENT: 'CAT-ddc9b8e0-a9a1-e31e-a467-2c33e553afd9',
  AUTO_INSURANCE: 'CAT-de7c2dc7-90e6-85a2-6509-5ec10942e887',
  PROPERTY_TAX: 'CAT-dfdf9324-3c48-589d-8886-bb21bb73b5d6',
  DOMAIN_NAMES: 'CAT-e7c5ebc7-f73d-955a-db06-3724bbcf6faa',
  HOME_SUPPLIES: 'CAT-e671e3a1-b7cb-f0a9-ac6e-bc4632245c31',
  ADVERTISING: 'CAT-e6682ebe-f239-c654-8233-0970b94cc162',
  CHECK: 'CAT-ea6db36f-3985-719d-1304-ccb7eeef5ecc',
  DENTIST: 'CAT-ee48b740-c981-778b-3c02-04540dec0262',
  BONUS: 'CAT-f52f2a88-2cb6-04e4-e36a-58f7b7c6a798',
  PET_FOOD_SUPPLIES: 'CAT-fbcdb437-2533-2857-1d1a-0624c9d9e1dc',
}

export const PaymentCategories = [
  CategoryGuids.CREDIT_CARD_PAYMENT,
  CategoryGuids.MORTGAGE_PAYMENT,
  CategoryGuids.AUTO_PAYMENT,
]

export const CategoryGuidToName = {
  // Top-level categories
  [CategoryGuids.AUTO_AND_TRANSPORT]: 'Auto & Transport',
  [CategoryGuids.BILLS_AND_UTILITIES]: 'Bills & Utilities',
  [CategoryGuids.BUSINESS_SERVICES]: 'Business Services',
  [CategoryGuids.EDUCATION]: 'Education',
  [CategoryGuids.ENTERTAINMENT]: 'Entertainment',
  [CategoryGuids.FEES_AND_CHARGES]: 'Fees & Charges',
  [CategoryGuids.FINANCIAL]: 'Financial',
  [CategoryGuids.FOOD_AND_DINING]: 'Food & Dining',
  [CategoryGuids.GIFTS_AND_DONATIONS]: 'Gifts & Donations',
  [CategoryGuids.HEALTH_AND_FITNESS]: 'Health & Fitness',
  [CategoryGuids.HOME]: 'Home',
  [CategoryGuids.INCOME]: 'Income',
  [CategoryGuids.INVESTMENTS]: 'Investments',
  [CategoryGuids.KIDS]: 'Kids',
  [CategoryGuids.PERSONAL_CARE]: 'Personal Care',
  [CategoryGuids.PETS]: 'Pets',
  [CategoryGuids.SHOPPING]: 'Shopping',
  [CategoryGuids.TAXES]: 'Taxes',
  [CategoryGuids.TRANSFER]: 'Transfer',
  [CategoryGuids.TRAVEL]: 'Travel',
  [CategoryGuids.UNCATEGORIZED]: 'Uncategorized',
  // Subcategories
  [CategoryGuids.LOCAL_TAX]: 'Local Tax',
  [CategoryGuids.WITHDRAWAL]: 'Withdrawal',
  [CategoryGuids.TRADE_COMMISSIONS]: 'Trade Commissions',
  [CategoryGuids.BABYSITTER_DAYCARE]: 'Babysitter & Daycare',
  [CategoryGuids.CHILD_SUPPORT]: 'Child Support',
  [CategoryGuids.CREDIT_CARD_PAYMENT]: 'Credit Card Payment',
  [CategoryGuids.STUDENT_LOAN]: 'Student Loan',
  [CategoryGuids.LIFE_INSURANCE]: 'Life Insurance',
  [CategoryGuids.PRINTING]: 'Printing',
  [CategoryGuids.FINANCIAL_ADVISOR]: 'Financial Advisor',
  [CategoryGuids.INTEREST_INCOME]: 'Interest Income',
  [CategoryGuids.LATE_FEE]: 'Late Fee',
  [CategoryGuids.LAWN_GARDEN]: 'Lawn & Garden',
  [CategoryGuids.FINANCE_CHARGE]: 'Finance Charge',
  [CategoryGuids.FRAUD_PROTECTION]: 'Fraud Protection',
  [CategoryGuids.MOVIES_DVDS]: 'Movies & DVDs',
  [CategoryGuids.HOME_INSURANCE]: 'Home Insurance',
  [CategoryGuids.CASH]: 'Cash',
  [CategoryGuids.TUITION]: 'Tuition',
  [CategoryGuids.HEALTH_INSURANCE]: 'Health Insurance',
  [CategoryGuids.DIVIDEND_CAP_GAINS]: 'Dividend & Cap Gains',
  [CategoryGuids.ALCOHOL_BARS]: 'Alcohol & Bars',
  [CategoryGuids.LEGAL]: 'Legal',
  [CategoryGuids.PUBLIC_TRANSPORTATION]: 'Public Transportation',
  [CategoryGuids.MORTGAGE_RENT]: 'Mortgage & Rent',
  [CategoryGuids.HOTEL]: 'Hotel',
  [CategoryGuids.TRANSFER_FOR_CASH_SPENDING]: 'Transfer for Cash Spending',
  [CategoryGuids.UTILITIES]: 'Utilities',
  [CategoryGuids.DEPOSIT]: 'Deposit',
  [CategoryGuids.HOME_PHONE]: 'Home Phone',
  [CategoryGuids.SERVICE_PARTS]: 'Service Parts',
  [CategoryGuids.INTERNET]: 'Internet',
  [CategoryGuids.BOOKS]: 'Books',
  [CategoryGuids.NEWSPAPERS_MAGAZINES]: 'Newspapers & Magazines',
  [CategoryGuids.FAST_FOOD]: 'Fast Food',
  [CategoryGuids.COFFEE_SHOPS]: 'Coffee Shops',
  [CategoryGuids.SELL]: 'Sell',
  [CategoryGuids.OFFICE_SUPPLIES]: 'Office Supplies',
  [CategoryGuids.PET_GROOMING]: 'Pet Grooming',
  [CategoryGuids.AMUSEMENT]: 'Amusement',
  [CategoryGuids.BOOKS_SUPPLIES]: 'Books & Supplies',
  [CategoryGuids.VACATION]: 'Vacation',
  [CategoryGuids.SERVICE_FEE]: 'Service Fee',
  [CategoryGuids.GIFT]: 'Gift',
  [CategoryGuids.CHARITY]: 'Charity',
  [CategoryGuids.PARKING]: 'Parking',
  [CategoryGuids.SHIPPING]: 'Shipping',
  [CategoryGuids.ARTS]: 'Arts',
  [CategoryGuids.PAYCHECK]: 'Paycheck',
  [CategoryGuids.FURNISHINGS]: 'Furnishings',
  [CategoryGuids.RESTAURANTS]: 'Restaurants',
  [CategoryGuids.SPA_MASSAGE]: 'Spa & Massage',
  [CategoryGuids.RENTAL_CAR_TAXI]: 'Rental Car & Taxi',
  [CategoryGuids.ALLOWANCE]: 'Allowance',
  [CategoryGuids.BANKING_FEE]: 'Banking Fee',
  [CategoryGuids.BUY]: 'Buy',
  [CategoryGuids.STATE_TAX]: 'State Tax',
  [CategoryGuids.TOYS]: 'Toys',
  [CategoryGuids.KIDS_ACTIVITIES]: 'Kids Activities',
  [CategoryGuids.RENTAL_INCOME]: 'Rental Income',
  [CategoryGuids.VETERINARY]: 'Veterinary',
  [CategoryGuids.SPORTING_GOODS]: 'Sporting Goods',
  [CategoryGuids.LAUNDRY]: 'Laundry',
  [CategoryGuids.CLOTHING]: 'Clothing',
  [CategoryGuids.PHARMACY]: 'Pharmacy',
  [CategoryGuids.HOME_SERVICES]: 'Home Services',
  [CategoryGuids.ATM_FEE]: 'ATM Fee',
  [CategoryGuids.HAIR]: 'Hair',
  [CategoryGuids.GROCERIES]: 'Groceries',
  [CategoryGuids.GAS]: 'Gas',
  [CategoryGuids.FEDERAL_TAX]: 'Federal Tax',
  [CategoryGuids.HOSTING]: 'Hosting',
  [CategoryGuids.TELEVISION]: 'Television',
  [CategoryGuids.MOBILE_PHONE]: 'Mobile Phone',
  [CategoryGuids.BABY_SUPPLIES]: 'Baby Supplies',
  [CategoryGuids.MUSIC]: 'Music',
  [CategoryGuids.MORTGAGE_PAYMENT]: 'Mortgage Payment',
  [CategoryGuids.SPORTS]: 'Sports',
  [CategoryGuids.AUTO_PAYMENT]: 'Auto Payment',
  [CategoryGuids.GYM]: 'Gym',
  [CategoryGuids.REIMBURSEMENT]: 'Reimbursement',
  [CategoryGuids.AIR_TRAVEL]: 'Air Travel',
  [CategoryGuids.EYECARE]: 'Eyecare',
  [CategoryGuids.HOBBIES]: 'Hobbies',
  [CategoryGuids.SALES_TAX]: 'Sales Tax',
  [CategoryGuids.ELECTRONICS_SOFTWARE]: 'Electronics & Software',
  [CategoryGuids.DOCTOR]: 'Doctor',
  [CategoryGuids.RETURNED_PURCHASE]: 'Returned Purchase',
  [CategoryGuids.HOME_IMPROVEMENT]: 'Home Improvement',
  [CategoryGuids.AUTO_INSURANCE]: 'Auto Insurance',
  [CategoryGuids.PROPERTY_TAX]: 'Property Tax',
  [CategoryGuids.DOMAIN_NAMES]: 'Domain Names',
  [CategoryGuids.HOME_SUPPLIES]: 'Home Supplies',
  [CategoryGuids.ADVERTISING]: 'Advertising',
  [CategoryGuids.CHECK]: 'Check',
  [CategoryGuids.DENTIST]: 'Dentist',
  [CategoryGuids.BONUS]: 'Bonus',
  [CategoryGuids.PET_FOOD_SUPPLIES]: 'Pet Food & Supplies',
}

export const CategoryColors = {
  [CategoryGuids.AUTO_AND_TRANSPORT]: '#4B9DBC',
  [CategoryGuids.BILLS_AND_UTILITIES]: '#EF9B2C',
  [CategoryGuids.BUSINESS_SERVICES]: '#B3DE8C',
  [CategoryGuids.EDUCATION]: '#F8AB3A',
  [CategoryGuids.ENTERTAINMENT]: '#AB5B89',
  [CategoryGuids.FEES_AND_CHARGES]: '#FF9696',
  [CategoryGuids.FINANCIAL]: '#6BCDDB',
  [CategoryGuids.FOOD_AND_DINING]: '#58AC7B',
  [CategoryGuids.GIFTS_AND_DONATIONS]: '#347AA5',
  [CategoryGuids.HEALTH_AND_FITNESS]: '#5C446E',
  [CategoryGuids.HOME]: '#FFD84D',
  [CategoryGuids.INCOME]: '#133F49',
  [CategoryGuids.INVESTMENTS]: '#FF7070',
  [CategoryGuids.KIDS]: '#82D196',
  [CategoryGuids.PERSONAL_CARE]: '#338B7A',
  [CategoryGuids.PETS]: '#615BAB',
  [CategoryGuids.SHOPPING]: '#CF5F84',
  [CategoryGuids.TAXES]: '#32588D',
  [CategoryGuids.TRANSFER]: '#959CA6',
  [CategoryGuids.TRAVEL]: '#E37434',
  [CategoryGuids.UNCATEGORIZED]: '#FA5555',
}

export const CategoryIcon = {
  [CategoryGuids.AUTO_AND_TRANSPORT]: 'directions_car',
  [CategoryGuids.BILLS_AND_UTILITIES]: 'electrical_services',
  [CategoryGuids.BUSINESS_SERVICES]: 'business_center',
  [CategoryGuids.EDUCATION]: 'school',
  [CategoryGuids.ENTERTAINMENT]: 'stadium',
  [CategoryGuids.FEES_AND_CHARGES]: 'problem',
  [CategoryGuids.FINANCIAL]: 'price_check',
  [CategoryGuids.FOOD_AND_DINING]: 'grocery',
  [CategoryGuids.GIFTS_AND_DONATIONS]: 'featured_seasonal_and_gifts',
  [CategoryGuids.HEALTH_AND_FITNESS]: 'ecg_heart',
  [CategoryGuids.HOME]: 'cottage',
  [CategoryGuids.INCOME]: 'monetization_on',
  [CategoryGuids.INVESTMENTS]: 'bid_landscape',
  [CategoryGuids.KIDS]: 'face',
  [CategoryGuids.PERSONAL_CARE]: 'volunteer_activism',
  [CategoryGuids.PETS]: 'pet_supplies',
  [CategoryGuids.SHOPPING]: 'shopping_cart',
  [CategoryGuids.TAXES]: 'heap_snapshot_large',
  [CategoryGuids.TRANSFER]: 'compare_arrows',
  [CategoryGuids.TRAVEL]: 'airplane_ticket',
  [CategoryGuids.UNCATEGORIZED]: 'category',
  UNKNOWN: 'help',
}
